import { ItemList, ItemType } from '../../../UI/Cube/types'
import baseItems from '../baseItems'
import kandi from '../../../../assets/image/cube/tiles/02-Kandi.webp'

const items: ItemList = [
  {
    type: ItemType.IMAGE,
    src: kandi,
    //link: `${frontendDomain}/olafscholz`,
  },
  ...baseItems,
]

export default items
